import React from "react";
import SideBar from "../../components/Sidebar";

const FAQ = () => {
  return (
    <div className="container-fluid mt-3">
      <div className="row">
        {/* Sidebar */}
        <SideBar />

        {/* Main Content */}
        <div className="col-md-9 mb-3">
          <div className="card shadow-sm">
            <div className="card-body">
              <h5 className="card-title">Frequently Asked Questions (FAQs)</h5>
              <p className="mb-4">
                Find answers to common questions related to recharge, payments,
                and wallet services.
              </p>

              {/* Recharge & Bill Section */}
              <Section
                title="Recharge & Bill"
                id="accordionRecharge"
                faqs={[
                  {
                    question:
                      "Recharge is successful but I did not receive benefits.",
                    answer:
                      "If your recharge shows as successful but benefits (talktime/data/validity) are not received, please raise a complaint from the 'Recharge History' section. Once verified, the amount will be refunded within 30 minutes.",
                  },
                  {
                    question: "Recharge not done but my money was deducted.",
                    answer:
                      "If your recharge failed but money was deducted, the amount will be refunded instantly to your wallet. If you do not see the refund, please contact support with the transaction ID.",
                  },
                  {
                    question:
                      "I received a ‘Pending State’ message during recharge.",
                    answer:
                      "This means your transaction is under processing. Please wait 5–10 minutes. If the issue persists, raise a support ticket with transaction details.",
                  },
                  {
                    question: "I was not able to recharge.",
                    answer:
                      "Please check your internet connection and ensure your payment method is valid. If the issue continues, try re-initiating the transaction or contact support.",
                  },
                  {
                    question: "My recharge is showing as failed, why?",
                    answer:
                      "Please check that the mobile/DTH number and recharge plan are correct. If the plan is not valid or not supported by the operator for this number, the recharge will fail.",
                  },
                  {
                    question: "I recharged a wrong number.",
                    answer:
                      "Recharges done to an incorrect number cannot be cancelled or refunded. Please double-check the number before confirming the transaction.",
                  },
                ]}
              />

              {/* Payments Section */}
              <Section
                title="Payments"
                id="accordionPayments"
                faqs={[
                  {
                    question: "How can I add money to my wallet?",
                    answer:
                      "You can add money using the mobile app via UPI Intent only. Simply select 'Add Money', enter the amount, and complete the payment through your preferred UPI app.",
                  },
                  {
                    question: "Is it safe to make payments on your platform?",
                    answer:
                      "Yes, all payments are processed through secure and encrypted channels. We do not store your card or banking details.",
                  },
                ]}
              />

              {/* Wallet & Refunds Section */}
              <Section
                title="Wallet & Refunds"
                id="accordionWallet"
                faqs={[
                  {
                    question:
                      "What if my wallet is debited but recharge failed?",
                    answer:
                      "In case of a failed recharge, the debited amount will be auto-refunded back to your wallet within a few minutes.",
                  },
                  {
                    question: "How do I check my wallet balance?",
                    answer:
                      "Login to your account and go to the 'Wallet' section to view your current balance and transaction history.",
                  },
                  {
                    question: "How long does it take for refunds to reflect?",
                    answer:
                      "Refunds are usually processed instantly for wallet transactions and within 24–48 hours for bank/UPI transactions.",
                  },
                ]}
              />

              {/* Security Section */}
              <Section
                title="Account & Security"
                id="accordionSecurity"
                faqs={[
                  {
                    question: "How do I reset my password?",
                    answer:
                      "Click on the 'Forgot Password' option on the login page and follow the instructions to reset it securely.",
                  },
                  {
                    question: "Can I change my registered mobile number?",
                    answer:
                      "Currently, registered mobile numbers cannot be changed directly. Please contact support for assistance.",
                  },
                  {
                    question: "Is my personal data safe?",
                    answer:
                      "Yes, we follow strict data security practices to protect your personal and financial information.",
                  },
                ]}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// FAQ Accordion Section Component
const Section = ({ title, id, faqs }) => (
  <div className="mb-5">
    <div className="row">
      <div className="col-md-3">
        <h6 className="fw-bold">{title}</h6>
      </div>
      <div className="col-md-9">
        <div className="accordion accordion-flush" id={id}>
          {faqs.map((faq, index) => (
            <div className="accordion-item" key={index}>
              <h2 className="accordion-header" id={`heading-${id}-${index}`}>
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={`#collapse-${id}-${index}`}
                  aria-expanded="false"
                  aria-controls={`collapse-${id}-${index}`}
                >
                  {faq.question}
                </button>
              </h2>
              <div
                id={`collapse-${id}-${index}`}
                className="accordion-collapse collapse"
                aria-labelledby={`heading-${id}-${index}`}
                data-bs-parent={`#${id}`}
              >
                <div className="accordion-body">{faq.answer}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
    <hr />
  </div>
);

export default FAQ;
